var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',[_c('p',{domProps:{"innerHTML":_vm._s(_vm.text)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }